import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const evupvReducer = (state = {
    BarYearStromGesamtEVUPVUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_YearStromGesamtEvuPvClass_evupvReducer":
            return { ...state, BarYearStromGesamtEVUPVUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, BarYearStromGesamtEVUPVUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default evupvReducer;
